export default "__VITE_ASSET__DHeIUZLI__"